<section class="header desktop-visibility-flex">
	<div class="container">
		<div class="row no-gutter align-items-center">
			<div class="col-lg-4 col-md-12 links">
				<ul>
                    <li class="articles"><a href="/articles">Articles</a></li>
					<li class="nonprofits"><a href="/nonProfit">Non-Profits</a></li>                    
					<li class="resources"><a href="/resources">Resources & FAQ</a></li>
					<li class="aboutUs aboutLink" [ngClass]="isAboutUsActive ? 'active' : ''"><a href="/about-us">About</a></li>
					<!-- Release5 Article menu revert -->
				</ul>
			</div>
			<div class="col-lg-4 col-md-12 logo-wrap">
                <a href="/">
					<!-- <ng-container *ngIf="homeActive"><img src="./assets/images/logo.svg"></ng-container>
                    <ng-container *ngIf="!homeActive"><img class="newLogo"
                            src="./assets/images/logo_new.png"></ng-container> -->
					<!-- <ng-container><img class="newLogo" alt="logo" src="./assets/images/logo_new.webp"></ng-container> -->
					<picture>
						<source srcset="https://clg-prod-static.s3.us-east-2.amazonaws.com/Home+Page/desktop-logo.webp"
							type="image/webp">
						<img alt="logo"
							src="https://clg-prod-static.s3.us-east-2.amazonaws.com/Home+Page/desktop-logo.webp"
							fetchpriority="high">
					</picture>
				</a>
			</div>
			<div class="col-lg-1 col-md-12 links">
				<ul class="justify-content-end">
					<li class="aboutUs linkView" [ngClass]="isAboutUsActive ? 'active' : ''"><a href="/about-us">About</a></li>
					<!-- <li (click)="goToResources()" class="resources"><a>Resources & FAQ</a></li> -->
				</ul>
			</div>
			<div class="col-lg-3 col-md-12 buttons d-flex justify-content-end" *ngIf="!isLogin && !hideAuthBtn">
				<button class="btn btn-primary btn-block" (click)="onLogin()">LOG IN</button>
				<button class="btn btn-primary btn-block signUp" (click)="OnSignUp()">SIGN UP</button>
			</div>
			<div class="col-lg-3 col-md-12 d-flex justify-content-end align-items-center" *ngIf="isLogin">
				<!-- Loading indicator for getNotiCount -->
				<!-- <div class="loading-indicator" *ngIf="isLoading">
					<div class="spinner-border spinner-border-sm text-primary" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</div> -->
				<div class="notification" data-bs-toggle="dropdown" aria-expanded="false"
					[ngClass]="{'notification-no-data': !notificatonMessages.length}">
					<div [ngClass]="!notificatonMessages.length ? 'cp-n' : ''">
						<img src="./assets/images/notification.svg" alt="Notification" href="#" id="notificationList"
							role="button">
						<!-- <img *ngIf="!notificatonMessages.length" src="./assets/images/notification.svg" alt="Notification" class="no-data-inside"> -->
						<span *ngIf="notificationCount > 0"
							class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
							{{notificationCount}}
							<span class="visually-hidden">unread messages</span>
						</span>
					</div>
					<ul class="dropdown-menu" aria-labelledby="notificationList" *ngIf="notificatonMessages.length">
						<li *ngFor="let item of notificatonMessages.slice(0,5)">
							<a class="dropdown-item noti-dropdown-item" (click)="goToPage()">{{item['title']}}</a>
						</li>
						<li *ngIf="notificatonMessages.length > 5">
							<a class="dropdown-item view-all" (click)="goToPage()">View All</a>
						</li>
					</ul>
				</div>
				<div class="user-img">
					<img src="./assets/images/user.svg" width="25" height="25" alt="User">
				</div>
				<div class="user-detail">
					<p>Welcome!</p>
					<a class="nav-link dropdown-toggle userName" href="javascript:void(0)" id="navbarDropdown" role="button"
						(click)="toggleUserMenu($event)" aria-expanded="false" [class.show]="isUserMenuOpen">
						{{userName}}
					</a>
					<ul class="dropdown-menu" [class.show]="isUserMenuOpen" aria-labelledby="navbarDropdown">
						<ng-container *ngIf="!isAssociatedPartner">
						<li><a class="dropdown-item" href="/my-profile">My Profile</a></li>
						<!-- <li><a class="dropdown-item" href="/my-address">My Address</a></li> -->
						<li><a class="dropdown-item" href="/my-form-status">My Forms in Progress</a></li>
						<li><a class="dropdown-item" href="/my-files">My Completed Documents</a></li>
						<li><a class="dropdown-item" href="/shared-doc">Documents Shared with Me</a></li>
						</ng-container>
						<li><a *ngIf="isAssociatedPartner" class="dropdown-item myOrgNavLink" (click)="stopPropagation($event)" class="nav-link myOrg mg-b-0"
						[ngClass]="{'active1 mg-b-0': myOrgClicked2}">
						<div class="myOrg">My Organizations <img src='../../../assets/images/up-arrow-svg.svg'
								[ngStyle]="{'transform' : myOrgClicked2 ? '' : 'rotate(180deg)'  }" width="20"
								height="40"></div>
					
							</a>
					<div class="sub-menu-container" *ngIf="isAssociatedPartner && myOrgClicked2">
						<a class="dropdown-item myOrg-charities-navLink submenu" 
							href="/charities">
							Organization Information</a>
						<a class="dropdown-item myOrg-insights-navLink submenu"
							 href="/dashboard">
							Organization Dashboard</a>
					</div></li>
					<li>
						<a *ngIf="isAssociatedPartner" class="dropdown-item myOrgNavLink" (click)="stopPropagation($event);"
							class="nav-link myOrg mg-b-0" [ngClass]="{'active1 mg-b-0': myProfileClicked2}">
							<div class="myOrg">My Personal Use <img src='../../../assets/images/up-arrow-svg.svg'
									[ngStyle]="{'transform' : myProfileClicked2 ? '' : 'rotate(180deg)'  }" width="20" height="40"></div>
						</a>
					
						<div class="sub-menu-container" *ngIf="isAssociatedPartner && myProfileClicked2">
							<a class="dropdown-item myOrg-charities-navLink submenu"
								 href="/my-profile">
								My Profile</a>
							<a class="dropdown-item myOrg-insights-navLink submenu"
								 href="/my-form-status">
								My Forms in Progress</a>
							<a class="dropdown-item myOrg-insights-navLink"
								 href="/my-files">
								My Completed Documents</a>
							<a class="dropdown-item myOrg-insights-navLink"
								 href="/shared-doc">
								Documents Shared with
								Me</a>
							<a class="dropdown-item myOrg-insights-navLink" (click)="closeMenuModal()">
								Survey</a>
							</div>
					</li>
						<!-- <li *ngIf="isAssociatedPartner"><a class="dropdown-item" href="/charities">My Charities</a></li>
						<li *ngIf="isAssociatedPartner"><a class="dropdown-item" href="/dashboard">My Dashboard</a></li> -->
						<li><a class="dropdown-item" href="/change-password">Change Password</a></li>
						<!-- <li><a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#logoutModal">Logout</a>
                        </li> -->
						<ng-container *ngIf="!isAssociatedPartner">
						<li><a class="dropdown-item" (click)="closeMenuModal()">Survey</a></li>
						</ng-container>
						<li><a class="dropdown-item" (click)="logoutClicked()">Logout</a>
                        </li>
                    </ul>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="header mobile-visibility-flex">
	<div class="container">
		<div class="mobile-header">
			<div class="menu-item" (click)="menuCall()">
				<!-- <img src="./assets/images/menu.svg" alt="menu"> -->
				<span class="menu-label">&nbsp;Menu</span>
			</div>
			<div class="logo-wrap">
                <a href="/">
					<!-- <picture>
                        <source srcset="./assets/images/mobile-logo.webp" type="image/webp">
                        <img alt="logo" src="./assets/images/mobile-logo.webp" width="165" height="60" fetchpriority="high">
                      </picture> -->
					<!-- <picture>
						<source srcset="https://clg-prod-static.s3.us-east-2.amazonaws.com/Home+Page/mobile-logo.webp"
							type="image/webp">
						<img alt="logo"
							src="https://clg-prod-static.s3.us-east-2.amazonaws.com/Home+Page/mobile-logo.webp"
							width="165" height="52" fetchpriority="high">
					</picture> -->
					<!-- <img alt="logo" src="https://clg-stage-static.s3.us-east-2.amazonaws.com/Home+Page/mobile-logo.webp" width="165" height="60" fetchpriority="high"> -->
					 <img alt="logo" src="./assets/images/logo-mobile.png">
				</a>
			</div>
			<div class="icon-wrap" [ngStyle]="{'visibility': isLogin ? 'hidden' : 'visible'}">
                <a *ngIf="!isLogin" href="/login">
					<img src="./assets/images/user.svg" alt="User" fetchpriority="high">
				</a>
				<!-- <a *ngIf="isLogin" data-bs-toggle="modal" data-bs-target="#navModal" (click)="navCall()">
                    <img src="./assets/images/user.svg" alt="User">
                </a> -->
			</div>
		</div>
	</div>
</section>

<!-- <div class="modal fade" id="logoutModal" tabindex="-1" aria-labelledby="logoutModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="btn-close" (click)="closeMainMenuModal()" #cancelHeaderLogoutModal
                    data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <h5 class="modal-title" id="logoutModalLabel">Are you sure you want to logout?</h5>
                Click Ok to logout.
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                    (click)="closeMainMenuModal()">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="OnLogout()">Ok</button>
            </div>
        </div>
    </div>
</div> -->

<button style="display: none;" data-bs-toggle="modal" data-bs-target="#menuModal"
	class="btn btn-primary btn-block border-button" #openMenuModal></button>
<div class="modal fade" id="menuModal" tabindex="-1" aria-labelledby="menuModalLabel" aria-hidden="true" data-bs-backdrop="false">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-header">
				<img src='./assets/images/cross_blue.svg' #menuModalClose class="btn-close" data-bs-dismiss="modal"
					aria-label="Close">
				<div class="logo-wrap">
					<a>
						<!-- <picture>
							<source
								srcset="https://clg-stage-static.s3.us-east-2.amazonaws.com/Home+Page/mobile-logo.webp"
								type="image/webp">
							<img alt="logo"
								src="https://clg-stage-static.s3.us-east-2.amazonaws.com/Home+Page/mobile-logo.webp"
								width="165" height="52" fetchpriority="high">
						</picture> -->
						<img alt="logo" src="./assets/images/logo-mobile.png">
					</a>
				</div>
			</div>
			<div class="modal-body">
				<div class="nav-col mobile-visibility mobile-nav">
					<nav class="nav flex-column mb-4" id="navigation">
						<a class="nav-link article-nav-link" href="/articles">Articles</a>
						<a class="nav-link nonProfit-nav-link" href="/nonProfit">Non-Profits</a>
						<a class="nav-link resources-nav-link" href="/resources">Resources & FAQ</a>
						<a class="nav-link about-us-nav-link" href="/about-us">About</a>
						<!-- Release5 Article menu revert -->
						<a *ngIf="isAssociatedPartner" class="dropdown-item myOrgNavLink" (click)="myOrg($event)" class="nav-link myOrg mg-b-0"
						[ngClass]="{'active mg-b-0': myOrgClicked}">
						<div class="myOrg">My Organizations <img src='../../../assets/images/up-arrow-svg.svg'
								[ngStyle]="{'transform' : myOrgClicked ? '' : 'rotate(180deg)'  }" width="20"
								height="40"></div>
					</a>
					<ng-container *ngIf="isAssociatedPartner && myOrgClicked">
						<a class="dropdown-item myOrg-charities-navLink" class="myOrg-nav mg-b-1"
							[ngClass]="{'sub-menu-active': activeClass=='charities'}" href="/charities"
							style="box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.2); color: black !important;">
							Organization Information</a>
						<a class="dropdown-item myOrg-insights-navLink" class="myOrg-nav mg-b-0"
							[ngClass]="{'sub-menu-active': activeClass=='insights'}" href="/dashboard"
							style="color: black !important;">
							Organization Dashboard</a>
					</ng-container>

					<a *ngIf="isAssociatedPartner" class="dropdown-item myOrgNavLink" (click)="profile($event)" class="nav-link myOrg mg-b-0"
						[ngClass]="{'active mg-b-0': myProfileClicked}">
						<div class="myOrg">My Personal Use <img src='../../../assets/images/up-arrow-svg.svg'
								[ngStyle]="{'transform' : myProfileClicked ? '' : 'rotate(180deg)'  }" width="20"
								height="40"></div>
					</a>
					<ng-container *ngIf="isAssociatedPartner && myProfileClicked">
						<a class="dropdown-item myOrg-charities-navLink" class="myOrg-nav mg-b-1"
							[ngClass]="{'sub-menu-active': activeClass=='my-profile'}" href="/my-profile"
							style="box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.2); color: black !important;">
							My Profile</a>
						<a class="dropdown-item myOrg-insights-navLink" class="myOrg-nav mg-b-1"
							[ngClass]="{'sub-menu-active': activeClass=='my-form-status'}" href="/my-form-status"
							style="box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.2); color: black !important;">
							My Forms in Progress</a>
						<a class="dropdown-item myOrg-insights-navLink" class="myOrg-nav mg-b-1"
							[ngClass]="{'sub-menu-active': activeClass=='my-files'}" href="/my-files"
							style="box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.2); color: black !important;">
							My Completed Documents</a>
						<a class="dropdown-item myOrg-insights-navLink" class="myOrg-nav mg-b-1"
							[ngClass]="{'sub-menu-active': activeClass=='shared-doc'}" href="/shared-doc"
							style="box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.2); color: black !important;">
							Documents Shared with
							Me</a>
						<a class="dropdown-item myOrg-insights-navLink" class="myOrg-nav mg-b-0"
							[ngClass]="{'sub-menu-active': activeClass=='Survey'}" (click)="closeMenuModal()"
							style="color: black !important;">
							Survey</a>
					</ng-container>

					<ng-container *ngIf="!isAssociatedPartner">
						<a *ngIf="isLogin" class="nav-link profile-nav-link" href="/my-profile">My Profile</a>
						<!-- <a class="nav-link address-nav-link" href="/my-address">My Address</a> -->
						<a *ngIf="isLogin" class="nav-link forms-nav-link" href="/my-form-status">My Forms in
							Progress</a>
						<a *ngIf="isLogin" class="nav-link file-nav-link" href="/my-files">My Completed Documents</a>
						<a *ngIf="isLogin" class="nav-link shared-nav-link" href="/shared-doc">Documents Shared with
							Me</a>
						<a *ngIf="isLogin" class="nav-link" (click)="closeMenuModal()">Survey</a>
					</ng-container>
						<a *ngIf="isLogin" class="nav-link change-password-nav-link" href="/change-password">Change
							Password</a>
						<a *ngIf="isLogin" class="nav-link" (click)="logoutClicked()">Logout</a>
					</nav>
					<!-- <nav class="nav flex-column mb-4" id="navigation">

                </nav> -->
				</div>
			</div>
		</div>
	</div>
</div>

<div class="modal fade" id="navModal" tabindex="-1" aria-labelledby="logoutModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-header">
				<div class="left-side">
					<img src="./assets/images/cross_blue.svg" alt="close" data-bs-dismiss="modal" aria-label="Close">
					<div class="name-block">
						<span class="welcome">Welcome!</span>
						<span class="name">{{userName}}</span>
					</div>
				</div>
				<div class="right-side">
					<!-- <div class="notify">
                            <img src="./assets/images/notification.svg">
                    </div> -->
					<div class="notification" [ngClass]="{'notification-no-data': !notificatonMessages.length}">
						<div data-bs-toggle="dropdown" aria-expanded="false"
							[ngClass]="!notificatonMessages.length ? 'cp-n' : ''">
							<img src="./assets/images/notification.svg" alt="Notification" href="#"
								id="notificationList" role="button">
							<!-- <img *ngIf="!notificatonMessages.length" src="./assets/images/notification.svg" alt="Notification" class="no-data-inside"> -->
							<span *ngIf="notificationCount > 0"
								class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
								{{notificationCount}}
								<span class="visually-hidden">unread messages</span>
							</span>
						</div>
						<ul class="dropdown-menu" aria-labelledby="notificationList" *ngIf="notificatonMessages.length">
							<li *ngFor="let item of notificatonMessages.slice(0,5)">
								<a class="dropdown-item noti-dropdown-item" (click)="goToPage()" data-bs-dismiss="modal"
									aria-label="Close">{{item['title']}}</a>
							</li>
							<li *ngIf="notificatonMessages.length > 5">
								<a class="dropdown-item view-all" data-bs-dismiss="modal" aria-label="Close"
									(click)="goToPage()">View All</a>
							</li>
						</ul>
					</div>
				</div>
				<!-- <img src="./assets/images/cross_blue.svg" alt="" data-bs-dismiss="modal" aria-label="Close"> -->
				<!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
			</div>
			<div class="modal-body">
				<div class="nav-col mobile-visibility mobile-nav">
					<nav class="nav flex-column mb-4" id="navigation">
						<a class="nav-link profile-nav-link" href="/my-profile">My Profile</a>
						<!-- <a class="nav-link address-nav-link" href="/my-address">My Address</a> -->
						<a class="nav-link forms-nav-link" href="/my-form-status">My Forms in Progress</a>
						<a class="nav-link file-nav-link" href="/my-files">My Completed Documents</a>
						<a class="nav-link shared-nav-link" href="/shared-doc">Documents Shared with Me</a>
						<a class="nav-link change-password-nav-link" href="/change-password">Change Password</a>
						<a class="nav-link" (click)="closeMenuModal()">Survey</a>
						<a class="nav-link" (click)="logoutClicked()">Logout</a>
					</nav>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- <button style="display: none;" data-bs-toggle="modal" data-bs-target="#surveyModal"
    class="btn btn-primary btn-block border-button" #openSurveyModal></button>
<div class="modal fade" id="surveyModal" tabindex="-1" data-bs-keyboard="false" data-bs-backdrop="static"
    aria-labelledby="surveyModalLabel" aria-hidden="true" (hidden.bs.modal)="onSurveyModalClose()">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
            <app-survey-form></app-survey-form>
        </div>
    </div>
</div> -->

<!-- Terms of Use Modal - Centralized -->
<button style="display: none;" data-bs-toggle="modal" #openTermsModal data-bs-target="#termsModal">Open Terms Modal</button>
<div class="modal fade" id="termsModal" tabindex="-1" data-bs-keyboard="false" data-bs-backdrop="static" 
	 aria-labelledby="termsModalLabel" aria-hidden="true" *ngIf="showTermsModal">
	<div class="modal-dialog modal-dialog-centered modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<div class="header-content">
					<h2>Terms of Use</h2>
				</div>
			</div>
			<div class="modal-body" (scroll)="onModalBodyScroll()">
				<div class="modal-section active">
					<div class="section-content">
						<div class="terms-content" *ngIf="termsContent" [innerHTML]="termsContent">
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="left-btn-container">
					<label class="checkbox" *ngIf="getButtonText()=='Accept'">
						<input type="checkbox" [(ngModel)]="agreed" /> &nbsp;
						<span>I agree to the Terms of Use</span>
					</label>
				</div>
				<div class="right-btn-container">
					<button 
						type="button" 
						class="btn btn-primary" [ngClass]="{ 'disabled': isAtBottom && !agreed }"
						(click)="nextSection()">
						{{ getButtonText() }}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>